import React, { Component } from 'react';
import { Marker }           from "react-google-maps";
import PlaceMarkerInfo      from './containers/PlaceMarkerInfoContainer'
import icon                 from './../../assets/paddle.png';

class PlaceMarker extends Component
{
    renderInfoWindow = () =>
    {
        if (this.props.map.window === this.props.place.id)
        {
            return (
                <PlaceMarkerInfo />
            );
        }
        else
        {
            return null;
        }
    };

    getPin = () =>
    {
        if (null === this.props.pin)
        {
            return icon;
        }

        return this.props.pin;
    };

    render = () =>
    {
        return (
            <Marker
                title={ this.props.place.name }
                position={ { lat: this.props.place.coords.lat, lng: this.props.place.coords.long } }
                key={ this.props.place.id }
                icon={ this.getPin() }
                onClick={ this.props.openWindow.bind(this, this.props.place.id) }
            >
                { this.renderInfoWindow() }
            </Marker>
        );
    };

}

export default PlaceMarker;



// WEBPACK FOOTER //
// ./src/components/Map/PlaceMarker.js